import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaYoutube,
  FaEnvelope,
  FaPhone
} from "react-icons/fa";

import "../styles/footer.css";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* Brand */}

        <div className="footer-section">

          <h2>CompExams</h2>

          <p>
            Helping students prepare smarter with
            quality examination papers from
            junior, senior secondary and professional
            institutions.
          </p>

        </div>

        {/* Quick Links */}

        <div className="footer-section">

          <h3>Quick Links</h3>

          <ul>

            <li>
              <Link to="/">Home</Link>
            </li>

            <li>
              <Link to="/categories">
                Categories
              </Link>
            </li>

            <li>
              <Link to="/exams">
                Exams
              </Link>
            </li>

            <li>
              <Link to="/about">
                About
              </Link>
            </li>

            <li>
              <Link to="/contact">
                Contact
              </Link>
            </li>
           <li>
             <Link to="/privacy-policy">
               Privacy Policy
             </Link>
          </li>

          <li>
            <Link to="/terms">
              Terms & Conditions
            </Link>
          </li>
          </ul>

        </div>

        {/* Popular Categories */}

        <div className="footer-section">

          <h3>Popular Categories</h3>

          <ul>

            <li>8-4-4 papers</li>
            <li>CBE papers</li>
            <li>Revision papers</li>
            <li>Mocks and Pre-mocks</li>
            <li>Topical questions</li>

          </ul>

        </div>

        {/* Contact */}

        <div className="footer-section">

          <h3>Contact</h3>

          <p>

            <FaEnvelope />

            jjmzerah@gmail.com

          </p>

          <p>

            <FaPhone />

            +254 722563673

          </p>

          <div className="social-icons">

            <a href="/">
              <FaFacebook />
            </a>

            <a href="/">
              <FaTwitter />
            </a>

            <a href="https://www.youtube.com/@Robotec_company" target="_blank" rel="noopener noreferrer">
              <FaYoutube />
            </a>

          </div>

        </div>

      </div>

      <div className="footer-bottom">

        © {new Date().getFullYear()} CompExams.
        All Rights Reserved.

      </div>

    </footer>
  );
}

export default Footer;
